// extracted by mini-css-extract-plugin
export var contain = "giftcard_balance-module--contain--947cf";
export var content = "giftcard_balance-module--content--fe056";
export var copy = "giftcard_balance-module--copy--1de96";
export var dollars = "giftcard_balance-module--dollars--99c8f";
export var form = "giftcard_balance-module--form--676ce";
export var gift_balance = "giftcard_balance-module--gift_balance--ade95";
export var image = "giftcard_balance-module--image--69311";
export var img = "giftcard_balance-module--img--41a66";
export var img_desk = "giftcard_balance-module--img_desk--12ba7";
export var img_mob = "giftcard_balance-module--img_mob--54088";
export var result = "giftcard_balance-module--result--52581";
export var title = "giftcard_balance-module--title--9cb30";